import Vue from "vue";
import App from "./App.vue";
import "./assets/tailwind.css";
import axios from "axios";

import dayjs from "dayjs";
import ru from "dayjs/locale/ru";
//import weekday from "dayjs/plugin/weekday";
import utc from "dayjs/plugin/utc";

dayjs.locale(ru);
//dayjs.extend(weekday);
dayjs.extend(utc);

Object.defineProperties(Vue.prototype, {
  $dayjs: {
    get() {
      return dayjs;
    },
  },
});

window.axios = axios;

Vue.config.productionTip = false;

Vue.prototype.$axios = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_URL,
});

Vue.filter("humantime", function(value, time) {
  return dayjs
    .unix(value)
    .utc()
    .format("HH:mm");
});

const mountEl = document.querySelector("#mnkl-widget");
console.log(mountEl);
new Vue({
  render: (h) => h(App),
  beforeCreate() {
    Vue.prototype.$axios = axios.create({
      baseURL: process.env.VUE_APP_BACKEND_URL,
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "x-domain": mountEl.getAttribute("data-domain"),
      },
    });

    Vue.prototype.$deptId = mountEl.getAttribute("data-id");
  },
}).$mount("#mnkl-widget");
